export { default } from './FareListContainerMobile';
